import { Overlay } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  effect,
  OnDestroy,
  QueryList,
  TemplateRef,
  ViewChild,
  ViewChildren,
  ViewContainerRef,
  ViewEncapsulation,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseScrollbarDirective } from '@fuse/directives/scrollbar';
import { CreditPointCreatedToRefereeExpertWorkspaceNotificationComponent } from "@sprint-expert/app/modules/expert-event-notification/components/credit-point-created-to-referee-expert-workspace-notification.component";
import { CreditPointCreatedToReferrerExpertWorkspaceNotificationComponent } from '@sprint-expert/app/modules/expert-event-notification/components/credit-point-created-to-referrer-expert-workspace-notification.component';
import { ExpertCreatedNotificationComponent } from '@sprint-expert/app/modules/expert-event-notification/components/expert-created-notification.component';
import { ExpertMemberFoodCardFeedbackAwaitingNotificationComponent } from '@sprint-expert/app/modules/expert-event-notification/components/expert-member-food-card-feedback-awaiting-notification.component';
import { ExpertMemberFoodCardFeedbackCommentCreatedNotificationComponent } from '@sprint-expert/app/modules/expert-event-notification/components/expert-member-food-card-feedback-comment-created-notification.component';
import { ExpertMemberFoodCardFeedbackCommentEmojiReactionCreatedNotificationComponent } from '@sprint-expert/app/modules/expert-event-notification/components/expert-member-food-card-feedback-comment-emoji-reaction-created-notification.component';
import { ExpertMemberFoodCardFeedbackEmojiReactionCreatedNotificationComponent } from '@sprint-expert/app/modules/expert-event-notification/components/expert-member-food-card-feedback-emoji-reaction-created-notification.component';
import { ExpertMemberJoinedNotificationComponent } from '@sprint-expert/app/modules/expert-event-notification/components/expert-member-joined-notification.component';
import { ExpertMemberPassExpiringNotificationComponent } from '@sprint-expert/app/modules/expert-event-notification/components/expert-member-pass-expiring-notification.component';
import { ExpertMemberWorkoutFeedbackAwaitingNotificationComponent } from '@sprint-expert/app/modules/expert-event-notification/components/expert-member-workout-feedback-awaiting-notification.component';
import { ExpertMemberWorkoutFeedbackCommentCreatedNotificationComponent } from '@sprint-expert/app/modules/expert-event-notification/components/expert-member-workout-feedback-comment-created-notification.component';
import { ExpertMemberWorkoutFeedbackCommentEmojiReactionCreatedNotificationComponent } from '@sprint-expert/app/modules/expert-event-notification/components/expert-member-workout-feedback-comment-emoji-reaction-created-notification.component';
import { ExpertMemberWorkoutFeedbackEmojiReactionCreatedNotificationComponent } from '@sprint-expert/app/modules/expert-event-notification/components/expert-member-workout-feedback-emoji-reaction-created-notification.component';
import { ExpertSessionCommentEmojiReactionCreatedNotificationComponent } from '@sprint-expert/app/modules/expert-event-notification/components/expert-session-comment-emoji-reaction-created-notification.component';
import { ExpertSessionEmojiReactionCreatedNotificationComponent } from '@sprint-expert/app/modules/expert-event-notification/components/expert-session-emoji-reaction-created-notification.component';
import { ExpertSessionCommentCreatedNotificationComponent } from '@sprint-expert/app/modules/expert-event-notification/components/expert-session-feedback-comment-created-notification.component';
import { ExpertSessionCreatedNotificationComponent } from '@sprint-expert/app/modules/expert-event-notification/components/expert-session-created-notification.component';
import { ExpertSessionNotCompletedNotificationComponent } from '@sprint-expert/app/modules/expert-event-notification/components/expert-session-not-completed-notification.component';
import { ExpertSessionScheduleCreatedNotificationComponent } from '@sprint-expert/app/modules/expert-event-notification/components/expert-session-schedule-created-notification.component';
import { ExpertSessionScheduleReminderNotificationComponent } from '@sprint-expert/app/modules/expert-event-notification/components/expert-session-schedule-reminder-notification.component';
import { ExpertWorkspaceCreditPointExpiringNotificationComponent } from '@sprint-expert/app/modules/expert-event-notification/components/expert-workspace-credit-point-expiring-notification.component';
import { ExpertWorkspaceExpertJoinInquiryOpenedNotificationComponent } from '@sprint-expert/app/modules/expert-event-notification/components/expert-workspace-expert-join-inquiry-opened-notification.component';
import { FoodCardResolvedNotificationComponent } from '@sprint-expert/app/modules/expert-event-notification/components/food-card-resolved-notification.component';
import { MemberGeneralMissionCheckedByDateNotificationComponent } from '@sprint-expert/app/modules/expert-event-notification/components/member-general-mission-checked-by-date-notification.component';
import { MemberWorkoutMissionCheckedByDateNotificationComponent } from '@sprint-expert/app/modules/expert-event-notification/components/member-workout-mission-checked-by-date-notification.component';
import { EmptyExpertEventNotificationComponent } from '@sprint-expert/app/modules/expert-event-notification/empty-expert-event-notification.component';
import {
  injectExpertEventNotificationService,
  provideExpertEventNotificationService,
} from '@sprint-expert/app/modules/expert-event-notification/expert-event-notification.service';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { NgScrollbar } from 'ngx-scrollbar';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-expert-event-notification',
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    NgClass,
    NgTemplateOutlet,
    MatSlideToggleModule,
    FormsModule,
    EmptyExpertEventNotificationComponent,
    NgScrollbar,
    InfiniteScrollDirective,
    FoodCardResolvedNotificationComponent,
    ExpertCreatedNotificationComponent,
    ExpertMemberJoinedNotificationComponent,
    ExpertMemberPassExpiringNotificationComponent,
    ExpertMemberFoodCardFeedbackAwaitingNotificationComponent,
    ExpertMemberFoodCardFeedbackCommentCreatedNotificationComponent,
    ExpertMemberFoodCardFeedbackEmojiReactionCreatedNotificationComponent,
    ExpertMemberFoodCardFeedbackCommentEmojiReactionCreatedNotificationComponent,
    ExpertMemberWorkoutFeedbackAwaitingNotificationComponent,
    ExpertMemberWorkoutFeedbackCommentCreatedNotificationComponent,
    ExpertMemberWorkoutFeedbackEmojiReactionCreatedNotificationComponent,
    ExpertMemberWorkoutFeedbackCommentEmojiReactionCreatedNotificationComponent,
    ExpertSessionScheduleCreatedNotificationComponent,
    ExpertSessionScheduleReminderNotificationComponent,
    ExpertSessionCreatedNotificationComponent,
    ExpertSessionNotCompletedNotificationComponent,
    ExpertSessionCommentCreatedNotificationComponent,
    ExpertSessionEmojiReactionCreatedNotificationComponent,
    ExpertSessionCommentEmojiReactionCreatedNotificationComponent,
    ExpertWorkspaceExpertJoinInquiryOpenedNotificationComponent,
    ExpertWorkspaceCreditPointExpiringNotificationComponent,
    MemberGeneralMissionCheckedByDateNotificationComponent,
    MemberWorkoutMissionCheckedByDateNotificationComponent,
    CreditPointCreatedToReferrerExpertWorkspaceNotificationComponent,
    CreditPointCreatedToRefereeExpertWorkspaceNotificationComponent,
  ],
  providers: [provideExpertEventNotificationService()],
  templateUrl: 'expert-event-notification.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpertEventNotificationComponent implements OnDestroy {
  readonly vm = injectExpertEventNotificationService();

  @ViewChild('expertEventNotificationsOrigin')
  private _expertEventNotificationsOrigin: MatButton;
  @ViewChild('expertEventNotificationsPanel')
  private _expertEventNotificationsPanel: TemplateRef<any>;
  @ViewChildren(FuseScrollbarDirective)
  private _fuseScrollbarDirectives: QueryList<FuseScrollbarDirective>;

  /**
   * Constructor
   */
  constructor(
    private _overlay: Overlay,
    private _viewContainerRef: ViewContainerRef
  ) {
    effect(() => {
      if (this.vm.showOnlyUnread$$()) {
        if (this._fuseScrollbarDirectives) {
          this._fuseScrollbarDirectives.forEach(directive => {
            directive.scrollToTop(0);
          });
        }
      }
    });
  }

  ngOnDestroy(): void {
    // Dispose the overlay
    if (this.vm.overlayRef) {
      this.vm.overlayRef.dispose();
    }
  }

  openPanel(): void {
    this.vm.fetchExpertEventNotificationSlice();
    // Return if the expertEventNotifications panel or its origin is not defined
    if (
      !this._expertEventNotificationsPanel ||
      !this._expertEventNotificationsOrigin
    ) {
      return;
    }

    // Create the overlay if it doesn't exist
    if (!this.vm.overlayRef) {
      this._createOverlay();
    }

    // Attach the portal to the overlay
    this.vm.overlayRef.attach(
      new TemplatePortal(
        this._expertEventNotificationsPanel,
        this._viewContainerRef
      )
    );
  }

  closePanel(): void {
    this.vm.overlayRef.detach();
  }

  private _createOverlay(): void {
    // Create the overlay
    this.vm.overlayRef = this._overlay.create({
      hasBackdrop: true,
      backdropClass: 'fuse-backdrop-on-mobile',
      scrollStrategy: this._overlay.scrollStrategies.block(),
      positionStrategy: this._overlay
        .position()
        .flexibleConnectedTo(
          this._expertEventNotificationsOrigin._elementRef.nativeElement
        )
        .withLockedPosition(true)
        .withPush(true)
        .withPositions([
          {
            originX: 'start',
            originY: 'bottom',
            overlayX: 'start',
            overlayY: 'top',
          },
          {
            originX: 'start',
            originY: 'top',
            overlayX: 'start',
            overlayY: 'bottom',
          },
          {
            originX: 'end',
            originY: 'bottom',
            overlayX: 'end',
            overlayY: 'top',
          },
          {
            originX: 'end',
            originY: 'top',
            overlayX: 'end',
            overlayY: 'bottom',
          },
        ]),
    });

    this.vm.overlayRef.backdropClick().subscribe(() => {
      this.vm.overlayRef.detach();
    });
  }
}
